import { FrozenWidget } from '@app/collections/frozen'
import { Piteas } from '@app/collections/piteas'
import Head from 'next/head'

export default function BuyPage() {
  return (
    <>
      <Head>
        <title>Buy and Sell - Coast</title>
      </Head>
      {process.env.NEXT_PUBLIC_MAINTENANCE_MODE == 'true' ? (
        <>
          <FrozenWidget />
        </>
      ) : (
        <>
          <Piteas />
        </>
      )}
    </>
  )
}
